import { createFileRoute } from '@tanstack/react-router';
import { OnboardingGuidePage } from '@/components/OnboardingGuidePage';

export const Route = createFileRoute('/_authenticated/guia-inicio')({
  component: OnboardingGuidePage,
});
